<template>
  <el-dialog
      title="二维码生成"
      :visible.sync="dialogVisible"
      :width="dialogWidth"
  >
    <div id="qrcode-wrapper" ref="qrcodeWrapper" style="text-align: center">
      <div v-if="qrList.length" style="display: flex; flex-wrap: wrap; justify-content: center; gap: 20px;">
        <div v-for="(item, index) in qrList" :key="index" style="text-align: center;">
          <canvas :ref="'qrcodeCanvas_' + index"></canvas>
          <div style="margin-top: 8px; font-size: 13px; font-weight: bold;">
            {{ item.saleEntityName }}
          </div>
          <el-button size="mini" type="primary" style="margin-top: 6px;" @click="downloadOne(index)">下载</el-button>
        </div>
      </div>
      <template v-if="!qrList.length">
        <canvas ref="qrcodeCanvas"></canvas>
      </template>
      <div style="margin-top: 10px; font-size: 14px; font-weight: bold">
        <p v-if="qrName">{{ qrName }}</p>
        <p v-if="qrPhone">{{ qrPhone }}</p>
        <p v-if="qrContent">{{ qrContent }}</p>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button v-if="!qrContent && !qrList.length" type="primary" @click="downloadImage">下载二维码</el-button>
    </div>
  </el-dialog>
</template>

<script>
import QRCode from 'qrcode';
import {SaleEntityValueMap} from '@/utils/constants';

export default {
  data() {
    return {
      qrName: "",
      qrPhone: "",
      qrContent: "",
      qrData: "",
      qrList: [],
      dialogVisible: false,
    }
  },
  computed: {
    dialogWidth() {
      if (this.qrList.length <= 1) return '400px';
      if (this.qrList.length <= 2) return '520px';
      return '700px';
    }
  },
  methods: {
    hide() {
      this.dialogVisible = false;
    },

    showQRCodeList(name, phone, list) {
      this.qrName = `名字：${name}`;
      this.qrPhone = `电话：${phone}`;
      this.qrContent = "";
      this.qrList = list.map(item => ({
        url: item.url,
        saleEntity: item.saleEntity,
        saleEntityName: SaleEntityValueMap[item.saleEntity] || item.saleEntity,
      }));
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.qrList.forEach((item, index) => {
            const canvasArr = this.$refs['qrcodeCanvas_' + index];
            const canvas = Array.isArray(canvasArr) ? canvasArr[0] : canvasArr;
            if (canvas) {
              QRCode.toCanvas(canvas, item.url, {width: 200}, (error) => {
                if (error) console.error(error);
              });
            }
          });
        });
      });
    },

    showQRCode(name, phone, qrData) {
      this.qrList = [];
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.qrPhone = `电话：${phone}`;
        this.qrName = `名字：${name}`;
        this.qrData = qrData;
        const canvas = this.$refs.qrcodeCanvas;
        QRCode.toCanvas(canvas, this.qrData, {width: 200}, (error) => {
          if (error) console.error(error);
        });
      });
    },

    showQRCode1(content, qrData) {
      this.qrList = [];
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.qrContent = content;
        this.qrData = qrData;
        const canvas = this.$refs.qrcodeCanvas;
        QRCode.toCanvas(canvas, this.qrData, {width: 200}, (error) => {
          if (error) console.error(error);
        });
      });
    },

    downloadOne(index) {
      const item = this.qrList[index];
      const canvasArr = this.$refs['qrcodeCanvas_' + index];
      const canvas = Array.isArray(canvasArr) ? canvasArr[0] : canvasArr;
      if (!canvas) return;

      const canvasWithText = document.createElement("canvas");
      const ctx = canvasWithText.getContext("2d");
      const qrH = canvas.height;
      const qrW = canvas.width;
      canvasWithText.width = qrW;
      canvasWithText.height = qrH + 70;

      ctx.drawImage(canvas, 0, 0);
      ctx.font = "16px Arial";
      ctx.textAlign = "center";
      ctx.fillStyle = "#000";
      ctx.fillText(this.qrName, qrW / 2, qrH + 20);
      ctx.fillText(this.qrPhone, qrW / 2, qrH + 40);
      ctx.fillText(item.saleEntityName, qrW / 2, qrH + 60);

      const link = document.createElement("a");
      link.download = `qrcode_${item.saleEntityName}.png`;
      link.href = canvasWithText.toDataURL("image/png");
      link.click();
    },

    downloadImage() {
      const canvas = this.$refs.qrcodeCanvas;
      const canvasWithText = document.createElement("canvas");
      const ctx = canvasWithText.getContext("2d");
      const qrH = canvas.height;
      const qrW = canvas.width;
      canvasWithText.width = qrW;
      canvasWithText.height = qrH + 50;

      ctx.drawImage(canvas, 0, 0);
      ctx.font = "16px Arial";
      ctx.textAlign = "center";
      ctx.fillStyle = "#000";
      ctx.fillText(this.qrName, qrW / 2, qrH + 20);
      ctx.fillText(this.qrPhone, qrW / 2, qrH + 40);

      const link = document.createElement("a");
      link.download = "qrcode.png";
      link.href = canvasWithText.toDataURL("image/png");
      link.click();
    }
  }
};
</script>
